import { inject, Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { firstValueFrom } from 'rxjs';

import { GqlService } from '@shared/services/gql.service';

import { ForecastSettingsQuery } from './forecast-settings.query';
import { ForecastSettingsModel, ForecastSettingsStore } from './forecast-settings.store';

@Injectable({ providedIn: 'root' })
export class ForecastSettingsService {
  private forecastSettingsQuery = inject(ForecastSettingsQuery);
  private forecastSettingsStore = inject(ForecastSettingsStore);
  private gqlService = inject(GqlService);

  add(forecastSetting: ForecastSettingsModel) {
    this.forecastSettingsStore.add(forecastSetting);
  }

  remove(id: ID) {
    this.forecastSettingsStore.remove(id);
  }

  syncSetting(id: string) {
    const set = this.forecastSettingsQuery.getEntity(id);

    if (set) {
      const {
        activity_id,
        amount_type,
        category_id,
        driver,
        driver_setting_id,
        evidence_source,
        forecast_method,
        milestone_category,
        override,
        period_end_date,
        period_end_milestone_id,
        period_start_date,
        period_start_milestone_id,
      } = set;
      const updatedForecastSetting = {
        activity_id,
        amount_type,
        category_id,
        discount: false,
        driver,
        driver_setting_id: driver === null || !driver_setting_id ? null : driver_setting_id,
        evidence_source,
        forecast_method: driver === null ? null : forecast_method,
        milestone_category: driver === null ? null : milestone_category,
        override,
        period_end_date: driver === null ? null : period_end_date,
        period_end_milestone_id: driver === null ? null : period_end_milestone_id || null,
        period_start_date: driver === null ? null : period_start_date,
        period_start_milestone_id: driver === null ? null : period_start_milestone_id || null,
      };

      this.forecastSettingsStore.update(id, updatedForecastSetting);

      return firstValueFrom(this.gqlService.updateBudgetForecastSetting$(updatedForecastSetting));
    }

    return null;
  }

  update(id: string, forecastSetting: Partial<ForecastSettingsModel>) {
    this.forecastSettingsStore.update(id, forecastSetting);
  }
}
